import styled from "styled-components";

export const SuccessButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 25px auto;
  max-width: 280px;
`;